import { useCallback } from 'react';
import useHttp from '../http/useHttp';
import useUI from '../context/useUI';

export default function useUpdateEntityStatus() {
  const { showSnackbar } = useUI();
  const { putDataResponse, putData } = useHttp();

  const updateEntityStatus = useCallback(
    async (entityId: number, isDisabled: boolean) => {
      try {
        const url = `Entity/${entityId}/status?isDisabled=${isDisabled}`;
        const result = await putData(url);

        if (result?.status === 200) {
          showSnackbar(['Entity status updated successfully!'], 'success');
          return result.data;
        } else {
          showSnackbar(['Failed to update entity status.'], 'error');
          return null;
        }
      } catch (error) {
        console.error('updateEntityStatus error:', error);
        showSnackbar(['Error while updating entity status.'], 'error');
        return null;
      }
    },
    [putData, showSnackbar]
  );

  return { data: putDataResponse?.data ?? null, updateEntityStatus };
}
